import { api } from '../../../lib/api';
import { LoginCredentials, RegisterData, AuthResponse, StaffUser } from '../../../types';

export const authService = {
  /**
   * Login with email and password
   */
  async login(credentials: LoginCredentials): Promise<AuthResponse> {
    return api.post<AuthResponse>('/auth/login', credentials);
  },

  /**
   * Register a new staff account
   */
  async register(data: RegisterData): Promise<AuthResponse> {
    return api.post<AuthResponse>('/auth/register', data);
  },

  /**
   * Logout current user
   */
  async logout(): Promise<void> {
    return api.post<void>('/auth/logout');
  },

  /**
   * Get current user profile
   */
  async getCurrentUser(): Promise<StaffUser> {
    return api.get<StaffUser>('/auth/me');
  },

  /**
   * Refresh auth token
   */
  async refreshToken(refreshToken: string): Promise<{ token: string }> {
    return api.post<{ token: string }>('/auth/refresh', { refreshToken });
  },

  /**
   * Update user profile
   */
  async updateProfile(data: Partial<StaffUser>): Promise<StaffUser> {
    return api.patch<StaffUser>('/auth/profile', data);
  },

  /**
   * Change password
   */
  async changePassword(
    currentPassword: string,
    newPassword: string
  ): Promise<void> {
    return api.post<void>('/auth/change-password', {
      currentPassword,
      newPassword,
    });
  },

  /**
   * Set password (forced change on first login)
   */
  async setPassword(newPassword: string): Promise<void> {
    return api.post<void>('/auth/set-password', { new_password: newPassword });
  },

  /**
   * Request a password reset email
   */
  async forgotPassword(email: string): Promise<{ message: string }> {
    return api.post<{ message: string }>('/auth/forgot-password', { email });
  },

  /**
   * Reset password using a token from the email
   */
  async resetPassword(token: string, newPassword: string): Promise<{ message: string }> {
    return api.post<{ message: string }>('/auth/reset-password', { token, new_password: newPassword });
  },
};
